module.exports = __webpack_public_path__ + "static/media/relax.14e3510c.svg";